import useNotificationsStore from '@/stores/notifications';

const AUTO_CLOSE_MS = 5000;

function mapType(level) {
  const v = String(level || '').toLowerCase();
  if (v === 'error') return 'error';
  if (v === 'warning' || v === 'warn') return 'warning';
  if (v === 'success') return 'success';
  return 'info';
}

export default function handleRequestResponse(response, meta = {}) {
  const notificationsStore = useNotificationsStore();
  const { addNotification, closeNotification } = notificationsStore;

  const messages = response?.messages;
  if (!Array.isArray(messages) || !messages.length) return response;

  const isLogsEndpoint = String(meta?.path || '').startsWith('/logs/');

  for (const msg of messages) {
    if (!msg?.alert) continue;

    const type = mapType(msg?.level);

    if (isLogsEndpoint && (type === 'info' || type === 'success')) continue;

    const closable = msg?.closeable ?? true;

    const id = addNotification({
      type,
      title: msg?.title ?? null,
      message: msg?.text ?? '',
      detail: msg?.details ?? null,
      closable,
    });

    if (closable) {
      window.setTimeout(() => closeNotification(id), AUTO_CLOSE_MS);
    }
  }

  return response;
}
